<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { isCustomerForecastWithDiffLastMonthKey, TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';
import ForecastDiffLastMonthTableHead from './ForecastDiffLastMonthTableHead.vue';
import ForecastForReceiptTableHead from './ForecastForReceiptTableHead.vue';
// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    forecastStartYearMonth?: IYearMonth;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
}>();
//変数
const t = i18n.t;
</script>

<template>
  <ForecastDiffLastMonthTableHead
    v-if="isCustomerForecastWithDiffLastMonthKey(header.key)"
    :header="header"
    :header-index="headerIndex"
    :accumulation-table-content-width="accumulationTableContentWidth"
    :is-variable-width="isVariableWidth"
    :is-all-selected="isAllSelected"
    :stable-column-count="stableColumnCount"
    :forecast-start-year-month="forecastStartYearMonth"
    @on-click-sort="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)"
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  />
  <ForecastForReceiptTableHead
    v-else
    :header="header"
    :header-index="headerIndex"
    :accumulation-table-content-width="accumulationTableContentWidth"
    :is-variable-width="isVariableWidth"
    :is-all-selected="isAllSelected"
    :stable-column-count="stableColumnCount"
    :forecast-start-year-month="forecastStartYearMonth"
    @on-click-sort="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)"
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  />
</template>

<style scoped lang="scss"></style>
